import { ApiAction, PaginatedApiState, initialPaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Preorder from '../../models/Preorder';

export interface PreorderListState extends PaginatedApiState {
  preorders?: Preorder[]
}

const PreorderList = (state: PreorderListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PreorderListState>('PREORDER_LIST')(state, action)
  }
}

export default PreorderList